import { render, staticRenderFns } from "./First_Charge.vue?vue&type=template&id=96ba74a4&scoped=true"
import script from "./First_Charge.vue?vue&type=script&lang=js"
export * from "./First_Charge.vue?vue&type=script&lang=js"
import style0 from "./First_Charge.vue?vue&type=style&index=0&id=96ba74a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96ba74a4",
  null
  
)

export default component.exports